import type { HelpFile } from '../../types/help'
import { SectionPropertiesTestIds } from '../../../testids/SectionPropertiesTestIds'

export const sectionPropertiesHelp: HelpFile = {
  docPage: '/docs/admin/form-layouts',
  texts: {
    [SectionPropertiesTestIds.sectionColumnsPropSelect]:
      'Number of columns the fields in this section are arranged into. Use one column for narrow forms, two for compact dense layouts.',
  },
}
